import { create } from "zustand";

export const useSidebarState = create((set) => ({
  state: true,
  setSidebar: (input) => set(() => ({ state: input })),
}));
